module.exports = __webpack_public_path__ + "img/files2.29f8e6fa.png";